import { createAsyncThunk } from '@reduxjs/toolkit';
import { pmProjectsService } from '../../../services/projectManagement/pmProjects.services';
import { showHideLoader } from '../../common/common.slice';


// Get projects list action
// change-req 
const getProjectsListAction = createAsyncThunk('pmProjectsSlice/getProjectsListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    // dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;
    return pmProjectsService.getProjectListService({
        ...payload,
        id: projectDetails?.projectManager?.id?? payload?.id
    })
        .then((response) => {
            // dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            // dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project center invoices list action
// change-req 
const getProjectInvoicesListAction = createAsyncThunk('pmProjectsSlice/getProjectInvoicesListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;
    
    return pmProjectsService.getProjectInvoicesListService({
        ...payload,
        pm_id: projectDetails?.projectManager?.id?? payload?.pm_id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project center invoice details action
// change-req 
const getProjectInvoiceDetailsAction = createAsyncThunk('pmProjectsSlice/getProjectInvoiceDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;
    return pmProjectsService.getProjectInvoiceDetailsService({
        ...payload,
        pm_id: projectDetails?.projectManager?.id?? payload?.pm_id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});


// modify invoice action
const updateInvoiceAction = createAsyncThunk('fmProjectsSlice/updateInvoiceAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    // dispatch(showHideLoader(true));
    
    const { login: { userObject } } = await getState() as any;

    return pmProjectsService.updateInvoiceService({
        ...payload,
        id: userObject?.id
    })
        .then((response) => {
            // dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            // dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Release project center invoice action
// change-req 
const releaseInvoicesAction = createAsyncThunk('pmProjectsSlice/releaseInvoicesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    
    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.releaseInvoiceService({
        ...payload,
        pm_id: projectDetails?.projectManager?.id?? payload?.pm_id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Upload project center invoice action
const uploadPdfForInvoiceAction = createAsyncThunk('pmProjectsSlice/uploadPdfForInvoiceAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    return pmProjectsService.uploadPdfForInvoiceService(payload)
    .then((response) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return rejectWithValue(error?.response)
    })
});

// Upload project center change order action
const uploadPdfForChangeOrderAction = createAsyncThunk('pmProjectsSlice/uploadPdfForChangeOrderAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));
    return pmProjectsService.uploadPdfForChangeOrderService(payload)
    .then((response) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return response
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)
      return rejectWithValue(error?.response)
    })
});

// Get project overview details action
// change-req 
const getProjectOverviewDetailsAction = createAsyncThunk('pmProjectsSlice/getProjectOverviewDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.projectOverviewDetailsService({
        ...payload,
        id: projectDetails?.projectManager?.id?? payload?.id
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project timeline task-list action
// change-req 
const getProjectTimelineListAction = createAsyncThunk('pmProjectsSlice/getProjectTimelineListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.getProjectTimelineListService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Update project task connections action
// change-req
const updateTaskConnectionAction = createAsyncThunk('pmProjectsSlice/updateTaskConnectionAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }
    
    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.updateTaskConnectionsService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project phase tasks list action
// change-req
const getProjectTasksListAction = createAsyncThunk('pmProjectsSlice/getProjectTasksListAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.getProjectTasksService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        // response is being altered in the slice
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project overview task details action
// change-req
const getProjectOverviewTaskDetailsAction = createAsyncThunk('pmProjectsSlice/getProjectOverviewTaskDetailsAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.projectOverviewTaskDetailsService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 500)
            return response;
        })
        .catch((error: {response: unknown;}) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 500)
            return rejectWithValue(error?.response);
        });
});

// Get project milestones action
const getProjectMilestonesAction = createAsyncThunk('pmProjectsSlice/getProjectMilestonesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    return pmProjectsService.projectMilestonesService({
        ...payload,
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Get project phases action
// change-req
const getProjectPhasesAction = createAsyncThunk('pmProjectsSlice/getProjectPhasesAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.getProjectPhasesList({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Add project task action
// change-req
const addProjectTaskAction = createAsyncThunk('pmProjectsSlice/addProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.addProjectTaskService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Update project task action
// change-req 
const updateProjectTaskAction = createAsyncThunk('pmProjectsSlice/updateProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.updateProjectTaskService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Delete project task action
// change-req
const deleteProjectTaskAction = createAsyncThunk('pmProjectsSlice/deleteeProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    dispatch(showHideLoader(true));

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.deleteProjectTaskService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: {response: unknown;}) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        });
});

// Inline update project task action
// change-req 
const inlineUpdateProjectTaskAction = createAsyncThunk('pmProjectsSlice/inlineUpdateProjectTaskAction', async(payload: any, {getState, dispatch, rejectWithValue}) =>{
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }

    const { salesProjects: { projectDetails } } = await getState() as any;

    return pmProjectsService.inlineUpdateProjectTaskService({
        ...payload,
        pmId: projectDetails?.projectManager?.id?? payload?.pmId
    })
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 1500)
            return response;
        })
        .catch((error: {response: unknown;}) => {
            setTimeout(() => {
                dispatch(showHideLoader(false))
            }, 1500)
            return rejectWithValue(error?.response);
        });
});

// get change order Action
const getChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/getChangeOrderAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.getChangeOrderService(payload)
        .then((response) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return response
        })
        .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
        })
    }
  );

// get change order items Action
const getChangeOrderItemsAction = createAsyncThunk(
    'pmProjectsSlice/getChangeOrderItemsAction', (payload: any, { dispatch, rejectWithValue }) => {
        //   dispatch(showHideLoader(true));
        return pmProjectsService.getChangeOrderItemsService(payload)
            .then((response) => {
                //   setTimeout(() => {
                //     dispatch(showHideLoader(false))
                //   }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                //   setTimeout(() => {
                //     dispatch(showHideLoader(false))
                //   }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const createChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/createChangeOrderAction', (dealId: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.createChangeOrderService(dealId)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const saveChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/saveChangeOrderAction', ({change_order_id, payload, persistLoader}:any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.saveChangeOrderService(change_order_id, payload)
            .then((response) => {
                if(!persistLoader){
                    setTimeout(() => {
                        dispatch(showHideLoader(false))
                    }, 500)
                }
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// create change order Action
const getChangeOrderDetailsAction = createAsyncThunk(
    'pmProjectsSlice/getChangeOrderDetailsAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.getChangeOrderDetailsService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get change order terms Action
const getChangeOrderTermsAction = createAsyncThunk(
    'pmProjectsSlice/getChangeOrderTermsAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.getChangeOrderTermsService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);


// save change order notes Action
const saveChangeOrderNotesAction = createAsyncThunk(
    'pmProjectsSlice/saveChangeOrderNotesAction', ({change_order_id,payload}: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return pmProjectsService.saveChangeOrderNotesService(change_order_id,payload)
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// save change order Intro Action
const saveChangeOrderIntroAction = createAsyncThunk(
    'pmProjectsSlice/saveChangeOrderIntroAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.saveChangeOrderIntroService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const uploadChangeOrderPdfAction = createAsyncThunk(
    'pmProjectsSlice/uploadChangeOrderPdfAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.uploadChangeOrderPdfService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const changeOrderAttachmentListAction = createAsyncThunk(
    'pmProjectsSlice/changeOrderAttachmentListAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.changeOrderAttachmentListService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const removeChangeOrderAttachmentAction = createAsyncThunk(
    'pmProjectsSlice/removeChangeOrderAttachmentAction', (attachmentId: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.removeChangeOrderAttachmentService(attachmentId)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// upload change order pdf Action
const exportChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/exportChangeOrderAction', ({change_order_id,payload}: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.exportChangeOrderService(change_order_id,payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// delete change order Action
const deleteChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/deleteChangeOrderAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.deleteChangeOrderService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// duplicate change order Action
const duplicateChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/duplicateChangeOrderAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.duplicateChangeOrderService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get co payment schedule Action
const getCOPaymentScheduleAction = createAsyncThunk(
    'pmProjectsSlice/getCOPaymentScheduleAction', (change_order_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.getCOPaymentScheduleService(change_order_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// get co payment schedule Action
const updateCOPaymentScheduleAction = createAsyncThunk(
    'pmProjectsSlice/updateCOPaymentScheduleAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.updateCOPaymentScheduleService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Rfp List Action
const rfpListAction = createAsyncThunk(
    'pmProjectsSlice/rfpListAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.rfpListService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Create Rfp Action
const createRfpAction = createAsyncThunk(
    'pmProjectsSlice/createRfpAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.createRfpService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Update Rfp Action
const updateRfpAction = createAsyncThunk(
    'pmProjectsSlice/updateRfpAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.updateRfpService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// Unrelease change order Action
const unreleaseChangeOrderAction = createAsyncThunk(
    'pmProjectsSlice/unreleaseChangeOrderAction', (change_orde_id: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.unreleaseChangeOrder(change_orde_id)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// rearrange overview list Action
// change-req 
const rearrangeOverviewListAction = createAsyncThunk(
    'pmProjectsSlice/rearrangeOverviewListAction', async(payload: any, { getState, dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));

        const { salesProjects: { projectDetails } } = await getState() as any;

        return pmProjectsService.rearrangeProjectOverviewDetailsService({
            ...payload,
            userId: projectDetails?.projectManager?.id?? payload?.userId
        })
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);

// generate zip Action
const generateZipAction = createAsyncThunk(
    'pmProjectsSlice/generateZipAction', (payload: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return pmProjectsService.generateZip(payload)
            .then((response) => {
                setTimeout(() => {
                    // dispatch(showHideLoader(false))
                }, 500)
                return response
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false))
                }, 500)
                return rejectWithValue(error?.response)
            })
    }
);


// Project Camera Action
const getProjectCameraAction = createAsyncThunk(
    'pmProjectsSlice/getProjectCameraAction', (id: string, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.getProjectCameraService(id)
        .then((response: any) => {
          dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
          dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );
  
  // Project Camera Feed Action
  const getProjectCameraFeedsAction = createAsyncThunk(
    'pmProjectsSlice/getProjectCameraFeedsAction', (payload: any, { dispatch, rejectWithValue }) => {
    //   dispatch(showHideLoader(true));
      return pmProjectsService.getProjectCameraFeedsService(payload?.token)
        .then((response: any) => {
        //   dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
        //   dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );
  
  // Stop Project Camera Feed Action
  const stopProjectCameraFeedsAction = createAsyncThunk(
    'pmProjectsSlice/stopProjectCameraFeedsAction', (token: string, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.stopProjectCameraFeedsService(token)
        .then((response: any) => {
          dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
          dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );

  // Get project Rfqs Action
  const getProjectRfqsAction = createAsyncThunk(
    'pmProjectsSlice/getProjectRfqsAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.getProjectRfqsService(payload)
        .then((response: any) => {
          dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
          dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );

  // Get project Rfqs Action
  const getProjectRfqSubcontractorsAction = createAsyncThunk(
    'pmProjectsSlice/getProjectRfqSubcontractorsAction', (payload: any, { dispatch, rejectWithValue }) => {
    //   dispatch(showHideLoader(true));
      return pmProjectsService.getProjectRfqSubcontractorsService(payload)
        .then((response: any) => {
        //   dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
        //   dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );


 //  RFQS Details Action
 const getRfqsDetailsAction = createAsyncThunk(
    'pmProjectsSlice/getRfqsDetailsAction',(payload : any, {dispatch, rejectWithValue}) =>{
        dispatch(showHideLoader(true));
            return pmProjectsService.rfqsDetailsService(payload)
                .then((response: any) => {
                dispatch(showHideLoader(false))
            return response
            })
            .catch((error: { response: unknown; }) => {
                dispatch(showHideLoader(false))
                return rejectWithValue(error?.response)
            })
    }
)

 // upload Document / Media Files Action
 const uploadDocumentMediaFilesAction = createAsyncThunk(
    'pmProjectsSlice/uploadDocumentMediaFilesAction', ({payload, dealId, rfqId} : any, {dispatch, rejectWithValue}) =>{
        dispatch(showHideLoader(true));
        return pmProjectsService.uploadDocumentMediaServices(payload, dealId, rfqId)
                .then((response: any) => {
                dispatch(showHideLoader(false))
            return response
            })
            .catch((error: { response: unknown; }) => {
                dispatch(showHideLoader(false))
                return rejectWithValue(error?.response)
            })
    }
 )

//  delete Document / Media Files Action
const deleteDocumentMediaFilesAction = createAsyncThunk(
    'pmProjectsSlice/deleteDocumentMediaFilesAction',(payload : any, {dispatch, rejectWithValue}) =>{
        dispatch(showHideLoader(true));
            return pmProjectsService.deleteDocumentMediaService(payload)
                .then((response: any) => {
                dispatch(showHideLoader(false))
            return response
            })
            .catch((error: { response: unknown; }) => {
                // dispatch(showHideLoader(false))
                return rejectWithValue(error?.response)
            })
    }
)

// update the Document Order Action
const updateDocumentOrderAction = createAsyncThunk(
    'pmProjectsSlice/updateDocumentOrderAction',(payload : any, {dispatch, rejectWithValue}) =>{
        // dispatch(showHideLoader(true));
            return pmProjectsService.updateDocumentOrderService(payload)
                .then((response: any) => {
                // dispatch(showHideLoader(false))
            return response
            })
            .catch((error: { response: unknown; }) => {
                // dispatch(showHideLoader(false))
                return rejectWithValue(error?.response)
            })
    }
)

// Update project Rfq Action
const updateProjectRfqAction = createAsyncThunk(
    'pmProjectsSlice/updateProjectRfqAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.updateProjectRfqService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// Update project Rfq Action
const deleteProjectRfqAction = createAsyncThunk(
    'pmProjectsSlice/deleteProjectRfqAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.deleteProjectRfqService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// Update project Rfq Action
const submitManualBidAction = createAsyncThunk(
    'pmProjectsSlice/submitManualBidAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.submitManualBidService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
  );

  // Update project Rfq Action
  const rfqChangeClosingDateAction = createAsyncThunk(
    'pmProjectsSlice/rfqChangeClosingDateAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.rfqChangeClosingDateService(payload)
        .then((response: any) => {
          dispatch(showHideLoader(false))
          return response
        })
        .catch((error: { response: unknown; }) => {
          dispatch(showHideLoader(false))
          return rejectWithValue(error?.response)
        })
    }
  );

//  get RFQ PDF / Generate RFQ PDF Action
 const getRfqPdfAction = createAsyncThunk(
 'pmProjectsSlice/getRfqPdfAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.generateRfqPdfService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
 )

//  get RFQ PDF / Generate RFQ PDF Action
const rejectBidAction = createAsyncThunk(
 'pmProjectsSlice/rejectBidAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.rejectBidService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
 )

//  Accept Bid Action
const acceptBidAction = createAsyncThunk(
 'pmProjectsSlice/acceptBidAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.acceptBidService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
 )

//  get Purchase order List Action
const getPurchaseOrderListAction = createAsyncThunk(
 'pmProjectsSlice/getPurchaseOrderListAction', (payload: any, { dispatch, rejectWithValue }) => {
    if(!payload?.hideLoader){
        dispatch(showHideLoader(true));
    }
    return pmProjectsService.getPurchaseOrderListService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
)

// purchase order review action
const poReviewAction = createAsyncThunk(
    'pmProjectsSlice/poReviewAction', (payload: any, { dispatch, rejectWithValue }) => {
        // dispatch(showHideLoader(true));
        return pmProjectsService.poReviewService(payload)
            .then((response: any) => {
                // dispatch(showHideLoader(false))
                return response
            })
            .catch((error: { response: unknown; }) => {
                // dispatch(showHideLoader(false))
                return rejectWithValue(error?.response)
            })
        }
    )


//  get accepted RFQ bids List Action
const getAcceptedRfqBidsListingAction = createAsyncThunk(
    'pmProjectsSlice/getAcceptedRfqBidsListingAction', (payload: any, { dispatch, rejectWithValue }) => {
       dispatch(showHideLoader(true));
       return pmProjectsService.getAcceptedRfqBidsListingService(payload)
           .then((response: any) => {
               dispatch(showHideLoader(false))
               return response
           })
           .catch((error: { response: unknown; }) => {
               dispatch(showHideLoader(false))
               return rejectWithValue(error?.response)
           })
       }
   )

//  create Purchase Order Action
const createPurchaseOrderAction = createAsyncThunk(
    'pmProjectsSlice/createPurchaseOrderAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.createPurchaseOrderService(payload)
            .then((response: any) => {
                dispatch(showHideLoader(false));
                return response;
            })
            .catch((error: { response: unknown; }) => {
                dispatch(showHideLoader(false));
                return rejectWithValue(error?.response);
            })
    }
);

// get Purchase order Details
const purchaseOrderDetailsAction = createAsyncThunk(
 'pmProjectsSlice/purchaseOrderDetailsAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.getPODetailsService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// upload DocumentMedia Action for Purchase Order
const uploadPODocumnetMediaAction = createAsyncThunk(
    'pmProjectsSlice/uploadDocumnetMediaPOAction', ({payload, poId} : any,{ dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.uploadPODocumentMediaServices(payload, poId)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// Change Purchase order Attachments Sequence Action
const changePOAttachementSequenceAction = createAsyncThunk(
    'pmProjectsSlice/changePOAttachementSequenceAction', (payload: any, { dispatch, rejectWithValue }) => {
    //  dispatch(showHideLoader(true));       
    return pmProjectsService.changePOFileAttachmentSequence(payload)
        .then((response: any) => {
            // dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            // dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);


// Delete PO File Attachment Action
const deletePOFileAttachmentAction = createAsyncThunk(
    'pmProjectsSlice/deletePOFileAttachmentAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.deletePOFileAttachmentService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);


// Get PO Payment Schedule Action
const getPOPaymentScheduleAction = createAsyncThunk(
    'pmProjectsSlice/getPOPaymentScheduleAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.getPOPaymentScheduleService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// Save PO Payment Schedule
const savePOPaymentScheduleAction = createAsyncThunk(
    'pmProjectsSlice/savePOPaymentScheduleAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.savePOPaymentScheduleService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
    }
);

// update PO Details Services
const updatePODetailsAction = createAsyncThunk(
  'proposalSlice/updatePODetailsAction', (payload:any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.updatePODetailsService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
   }
)

// release PO Action
const releasePurchaseOrderAction = createAsyncThunk(
  'pmProjectsSlice/releaePurchaseOrderAction', (payload:any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.releasePurchaseOrderService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
   }
)

// delete Purchase Order Action
const deletePurchaseOrderAction = createAsyncThunk(
  'pmProjectsSlice/deletePurchaseOrderAction', (payload:any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.deletePurchaseOrderService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
   }
)

// unrelease Purchase Order Action
const unreleasePurchaseOrderAction = createAsyncThunk(
  'pmProjectsSlice/unreleasePurchaseOrderAction', (payload:any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.unreleasePurchaseOrderService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false))
            return response
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false))
            return rejectWithValue(error?.response)
        })
   }
)

// export purchase order action
const exportPurchaseOrderAction = createAsyncThunk(
    'pmProjectsSlice/exportPurchaseOrderAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return pmProjectsService.exportPurchaseOrder(payload)
            .then((response: any) => {
                dispatch(showHideLoader(false));
                return response;
            })
            .catch((error: { response: unknown; }) => {
                dispatch(showHideLoader(false));
                return rejectWithValue(error?.response);
            })
    }
);

// Fetch Expense Action
const getProjectExpenseAction = createAsyncThunk(
    'pmProjectSlice/getProjectExpenseAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.getProjectExpenseList(payload)
        .then((response: any) => {
            setTimeout(() =>{
                dispatch(showHideLoader(false));
            },1500)
            return response;
        })
        .catch((error: { response: unknown; }) => {
            setTimeout(() =>{
                dispatch(showHideLoader(false));
            },500)
            return rejectWithValue(error?.response);
        })
    }
)

// Get Payment Review Action
const getExpensesPaymentReviewAction = createAsyncThunk(
  'pmProjectsSlice/getExpensesPaymentReviewAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      return pmProjectsService.getExpensesPaymentReviewService(payload)
        .then((response: any) => {
            dispatch(showHideLoader(false));
            return response;
        })
        .catch((error: { response: unknown; }) => {
            dispatch(showHideLoader(false));
            return rejectWithValue(error?.response);
        })
    }
)

// Update The Expense Action
const updateExpenseAction = createAsyncThunk(
  'pmProjectsSlice/updateExpenseAction', (payload: any, { dispatch, rejectWithValue }) => {
        if(!payload?.hideLoader){
            dispatch(showHideLoader(true));
        }
        return pmProjectsService.updateExpenseService(payload)
            .then((response: any) => {
                dispatch(showHideLoader(false));
                return response;
            })
            .catch((error: { response: unknown; }) => {
                dispatch(showHideLoader(false));
                return rejectWithValue(error?.response);
            })
    }
)

// Create Note For Expense Action
const createExpenseNoteAction = createAsyncThunk(
  'pmProjectsSlice/createExpenseNoteAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return pmProjectsService.createExpenseNoteService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Get Subcontractor Notes Action 
const getExpenseNotesAction = createAsyncThunk(
  'pmProjectsSlice/getExpenseNotesAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return pmProjectsService.getExpenseNotesService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Approve Expense Action
const approveExpenseAction = createAsyncThunk(
  'pmProjectsSlice/approvePaymentAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return pmProjectsService.approveExpenseService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Reject Expense Action
const rejectExpenseAction = createAsyncThunk(
  'pmProjectsSlice/rejectPaymentAction', (payload: any, {dispatch, rejectWithValue}) =>{
      dispatch(showHideLoader(true));
      return pmProjectsService.rejectExpenseService(payload)
      .then((response) =>{
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// Attach Subcontractor To Expense Action
const attachSubcontractorToExpenseAction = createAsyncThunk(
  'pmProjectsSlice/attachSubcontractorToExpenseAction', (payload: any, {dispatch, rejectWithValue}) =>{
    //   dispatch(showHideLoader(true));
      return pmProjectsService.attachSubcontractorToExpenseService(payload)
      .then((response) =>{
          setTimeout(() => {
            //   dispatch(showHideLoader(false))
          },500)
          return response
      })
      .catch((error: { response: unknown; }) => {
          setTimeout(() => {
            // dispatch(showHideLoader(false))
          }, 500)
          return rejectWithValue(error?.response)
      })
  }
);

// export the CSV DATA
const exportCSVDataForRFQAction = createAsyncThunk(
  'pmProjectsSlice/exportCSVDataForRFQAction', (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(showHideLoader(true));
    return pmProjectsService.exportCSVDataForRFQService(payload)
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return response;
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return rejectWithValue(error?.response);
    })
  }
);



// Get global RFQ attachments action
const getGlobalRfqAttachmentsAction = createAsyncThunk(
  'pmProjectsSlice/getGlobalRfqAttachmentsAction', (payload: any, { dispatch, rejectWithValue }) => {
    if (!payload?.hideLoader) {
      dispatch(showHideLoader(true));
    }
    return pmProjectsService.getGlobalRfqAttachmentsService(payload)
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return response;
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return rejectWithValue(error?.response);
    })
  }
);

// Upload global RFQ attachment action
const uploadGlobalRfqAttachmentAction = createAsyncThunk(
  'pmProjectsSlice/uploadGlobalRfqAttachmentAction', (payload: any, { dispatch, rejectWithValue }) => {
    if (!payload?.hideLoader) {
      dispatch(showHideLoader(true));
    }
    return pmProjectsService.uploadGlobalRfqAttachmentService(payload)
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return response;
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return rejectWithValue(error?.response);
    })
  }
);

// Delete global RFQ attachment action
const deleteGlobalRfqAttachmentAction = createAsyncThunk(
  'pmProjectsSlice/deleteGlobalRfqAttachmentAction', (payload: any, { dispatch, rejectWithValue }) => {
    if (!payload?.hideLoader) {
      dispatch(showHideLoader(true));
    }
    return pmProjectsService.deleteGlobalRfqAttachmentService(payload)
    .then((response) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return response;
    })
    .catch((error: { response: unknown; }) => {
      setTimeout(() => {
        dispatch(showHideLoader(false));
      }, 500);
      return rejectWithValue(error?.response);
    })
  }
);
// get proposales autopcomplete action
const projectAutocompleteAction = createAsyncThunk(
    'salesSlice/proposalsAutocompleteAction', (search: string, { dispatch, rejectWithValue }) => {
      // dispatch(showHideLoader(true));
      return pmProjectsService.projectAutocompleteService(search)
        .then((response) => {
          // setTimeout(() => {
          //   dispatch(showHideLoader(false))
          // }, 500)
          return response
        })
        .catch((error: { response: unknown; }) => {
          // setTimeout(() => {
          //   dispatch(showHideLoader(false))
          // }, 500)
          return rejectWithValue(error?.response)
        })
    }
  );

// copy timeline from project
const copyTimelineFromProjectAction = createAsyncThunk(
    'pmProjectsSlice/copyTimelineFromProjectAction', (payload: any, { dispatch, rejectWithValue }) => {
      dispatch(showHideLoader(true));
      
      return pmProjectsService.copyTimelineFromProjectService(payload)
        .then((response) => {
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return response;
        })
        .catch((error: { response: unknown; }) => {
          setTimeout(() => {
              dispatch(showHideLoader(false))
          },500)
          return rejectWithValue(error?.response);
        })
    }
  );

// Export all Projects Action
export const pmProjectsAction = {
    getProjectsListAction,
    getProjectInvoicesListAction,
    getProjectInvoiceDetailsAction,
    updateInvoiceAction,
    releaseInvoicesAction,
    uploadPdfForInvoiceAction,
    uploadPdfForChangeOrderAction,
    getProjectOverviewDetailsAction,
    getProjectTimelineListAction,
    updateTaskConnectionAction,
    getProjectTasksListAction,
    getProjectOverviewTaskDetailsAction,
    getProjectMilestonesAction,
    getProjectPhasesAction,
    addProjectTaskAction,
    updateProjectTaskAction,
    deleteProjectTaskAction,
    inlineUpdateProjectTaskAction,
    getChangeOrderAction,
    getChangeOrderItemsAction,
    createChangeOrderAction,
    saveChangeOrderAction,
    getChangeOrderDetailsAction,
    getChangeOrderTermsAction,
    saveChangeOrderNotesAction,
    saveChangeOrderIntroAction,
    uploadChangeOrderPdfAction,
    changeOrderAttachmentListAction,
    removeChangeOrderAttachmentAction,
    exportChangeOrderAction,
    deleteChangeOrderAction,
    duplicateChangeOrderAction,
    getCOPaymentScheduleAction,
    updateCOPaymentScheduleAction,
    rfpListAction,
    createRfpAction,
    updateRfpAction,
    unreleaseChangeOrderAction,
    rearrangeOverviewListAction,
    generateZipAction,
    getProjectCameraAction,
    getProjectCameraFeedsAction,
    stopProjectCameraFeedsAction,
    getRfqsDetailsAction,
    uploadDocumentMediaFilesAction,
    deleteDocumentMediaFilesAction,
    updateDocumentOrderAction,
    getProjectRfqsAction,
    getProjectRfqSubcontractorsAction,
    updateProjectRfqAction,
    submitManualBidAction,
    deleteProjectRfqAction,
    rfqChangeClosingDateAction,
    getRfqPdfAction,
    rejectBidAction,
    acceptBidAction,
    getPurchaseOrderListAction,
    poReviewAction,
    purchaseOrderDetailsAction,
    uploadPODocumnetMediaAction,
    changePOAttachementSequenceAction,
    deletePOFileAttachmentAction,
    getPOPaymentScheduleAction,
    savePOPaymentScheduleAction,
    updatePODetailsAction,
    releasePurchaseOrderAction,
    deletePurchaseOrderAction,
    unreleasePurchaseOrderAction,
    getAcceptedRfqBidsListingAction,
    createPurchaseOrderAction,
    exportPurchaseOrderAction,
    getProjectExpenseAction,
    getExpensesPaymentReviewAction,
    updateExpenseAction,
    createExpenseNoteAction,
    getExpenseNotesAction,
    approveExpenseAction,
    rejectExpenseAction,
    attachSubcontractorToExpenseAction,
    exportCSVDataForRFQAction,
    getGlobalRfqAttachmentsAction,
    uploadGlobalRfqAttachmentAction,
    deleteGlobalRfqAttachmentAction,
    projectAutocompleteAction,
    copyTimelineFromProjectAction
}